import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useQuery } from 'react-query';

import getTimestamps from '../utils/api/getTimestamps';
import { filterTimestamps } from '../utils/timestamp';
import { Timestamp } from '../types/timestamp';
import { lookupTable } from '../store/translation/selectors';
import { getBBBVideoId } from '../utils/videoHelper';

interface Props {
  code?: string;
  book?: string;
  bbbId?: string;
}

const useTimestampsForSearch = ({ code, book, bbbId }: Props) => {
  const [timestamps, setTimestamps] = useState<Timestamp[] | undefined>();
  const lut = useSelector(lookupTable);
  const video = bbbId !== undefined ? lut?.lookupById(bbbId) : undefined;
  const videoId = getBBBVideoId(video);
  const expectedChapter = video?.chapter;

  const { data } = useQuery(
    ['timestampsForSearch', code, book, videoId, expectedChapter],
    async () => {
      setTimestamps(undefined);
      try {
        if (code !== undefined && book !== undefined) {
          return await getTimestamps(code, book, videoId, bbbId, expectedChapter);
        }

        return [];
      } catch (e) {
        return [];
      }
    },
    {
      staleTime: Infinity,
      cacheTime: Infinity,
    }
  );

  useEffect(() => {
    setTimestamps(filterTimestamps(bbbId, data ?? []));
  }, [bbbId, data]);

  return timestamps;
};

export default useTimestampsForSearch;
